<template>
    <div class="allTitle">
        <span>{{ title }}</span>
    </div>
</template>

<script>
export default {
    props: {
        title: {
            type: String,
            default: "",
        },
    },
    data() {
        return {};
    },
};
</script>

<style lang="less" scoped>
.allTitle {
    border-bottom: 1px solid #dbdbdb;
    padding: 30px 0;
    display: flex;
    align-items: center;
    font-weight: bold;
    font-size: 20px;
    &::before {
        content: "";
        width: 6px;
        height: 17px;
        background: #e14d29;
        border-radius: 1px 5px 1px 1px;
        margin-right: 10px;
    }
    span {
        display: -webkit-box; /* 必须设置此项才能生效 */
        -webkit-line-clamp: 1; /* 限制最大行数 */
        -webkit-box-orient: vertical; /* 垂直布局 */
        overflow: hidden; /* 超出部分隐藏 */
        text-overflow: ellipsis; /* 显示省略号 */
    }
}
</style>